exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vgv-field {\n  display: block;\n  box-sizing: border-box;\n  width: 100%;\n  height: 48px;\n  border-radius: 24px;\n  background: white;\n  border: 1px solid #bec9d4;\n  line-height: 46px;\n  padding: 0 12px;\n  font-size: 15px;\n  color: #41566c;\n  font-weight: bold;\n  outline: none;\n}\n.vgv-field iframe {\n  height: 50px;\n  width: 100%;\n}\n", ""]);

// exports
